import { Row } from 'antd'
import KButton from 'app/components/Modules/General/KButton'
import Icon from 'app/components/UI-Elements/General/Icon'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import { useHelpUrl } from 'app/lib/hooks/useHelpUrl'
import { useRentalCreate } from 'app/lib/hooks/useRentalCreate'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

const CreateOptions: React.FC = () => {
  const { tCore } = useTranslation({ scope: 'create_options', recordType: RecordType.overview })
  const { loading, createRental } = useRentalCreate()
  const helpCenterUrl = useHelpUrl()

  return (
    <Row gutter={[24, 24]}>
      <KCol card title={tCore({ id: 'title.create_rental' })} xl={24} xs={12}>
        <KButton
          recordType={RecordType.rental}
          loading={loading}
          action="create"
          onClick={() => createRental()}
          type="secondary"
          block
        />
      </KCol>
      <KCol card title={tCore({ id: 'title.help_center' })} xl={24} xs={12}>
        <KButton
          recordType={RecordType.overview}
          action="open_help"
          href={helpCenterUrl}
          type="secondary"
          icon={<Icon type="external_link" iconStyles={{ maxHeight: 20 }} />}
          block
        />
      </KCol>
    </Row>
  )
}

export default CreateOptions
